import { toRefs, ref, inject, computed } from 'vue';
import { KEYCODES } from '../../utils/component-lib.esm9.js';

//
var script = {
  props: {
    component: {
      type: String,
      default: 'div'
    },
    disabled: Boolean,
    href: String,
    to: String,
    value: [String, Number]
  },
  setup(props, _ref) {
    let {
      emit,
      attrs
    } = _ref;
    const {
      component,
      disabled,
      href,
      to,
      value
    } = toRefs(props);
    const root = ref(null);
    const {
      isInGroup,
      selected,
      onToggle,
      areUnselectedItemsDisabled
    } = inject('list-group', {
      isInGroup: false,
      selected: []
    });
    const isActive = computed(() => {
      return selected.value === value.value || Array.isArray(selected.value) && selected.value.includes(value.value);
    });
    const isDisabled = computed(() => {
      if (disabled.value) return true;
      if (!isActive.value && areUnselectedItemsDisabled.value) return true;
      return false;
    });
    const currentComponent = computed(() => {
      let tag = 'div';
      if (component.value !== 'div') tag = component.value;else if (href.value) tag = 'a';else if (to.value) tag = 'router-link';
      return tag;
    });
    const classes = computed(() => {
      return {
        'v-list-item--link': currentComponent.value === 'a' || currentComponent.value === 'button' || currentComponent.value === 'router-link' || isInGroup,
        'v-list-item--disabled': isDisabled.value
      };
    });
    const itemAttrs = computed(() => {
      const rootAttrs = {
        role: attrs.role || 'listitem'
      };
      if (isInGroup) {
        rootAttrs.tabindex = 0;
        rootAttrs.role = 'option';
        rootAttrs['aria-selected'] = String(isActive.value);
      }
      return rootAttrs;
    });
    function handleClick(e) {
      if (e.detail) root.value.blur();
      emit('click', e);
      if (isInGroup) onToggle(value.value);
    }
    function handleKeydown(e) {
      if (e.keyCode === KEYCODES.enter) handleClick(e);
      emit('keydown', e);
    }
    return {
      currentComponent,
      classes,
      itemAttrs,
      handleClick,
      handleKeydown,
      root,
      isActive,
      isDisabled
    };
  }
};
export { script as default };